<script>
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import { ref, watch } from "vue";
import { integer } from "@vuelidate/validators";
import $ from "jquery";

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  props: {
    soalStats: Object,
    getQuestionNumber: Function,
    list: Array,
    height: Number,
    nomorUrut: integer,
    currentPage: integer,
    selectAnswer: Function,
    currentQuestionMenjodohkan: Object,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
    backSoal: Function,
    nextSoal: Function,
  },

  emits: ["showImage", "modalProgressFinal"],
  setup(props) {
    // console.log("setup called");

    const items = ref([]);

    const updateItems = () => {
      const allAnswers = props.list.reduce((accumulator, currentValue) => {
        return [...accumulator, ...currentValue.jawaban];
      }, []);

      // Filter to unique answers by jawaban text
      const uniqueAnswers = allAnswers.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.jawaban === item.jawaban)
      );

      items.value = uniqueAnswers.map((item) => {
        const matchingSoal = props.list.find(
          (soal) => soal.jawaban_redis === item.jawaban
        );
        return {
          ...item,
          selectedSoal: matchingSoal ? matchingSoal.idsoal : null,
        };
      });
    };

    watch(() => props.list, updateItems, { immediate: true });

    const getList = () => {
      return items.value.filter((item) => !item.selectedSoal);
    };

    const getSelectedForSoal = (soal) => {
      return items.value.filter((item) => item.selectedSoal === soal.idsoal);
    };

    const draggingItem = ref(null);
    const startDrag = (event, item) => {
      draggingItem.value = item;
    };

    const onDrop = async (event, soal) => {
      const item = draggingItem.value;
      if (!item) return;

      if (getSelectedForSoal(soal).length > 0) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan!",
          text: "Hanya satu jawaban yang diizinkan untuk dipilih!",
        });
        // console.log(`Hanya satu jawaban yang diizinkan untuk masuk!`);
        return;
      }

      const oldSoalId = item.selectedSoal;
      if (oldSoalId && oldSoalId !== soal.idsoal) {
        const oldSoal = props.list.find((s) => s.idsoal === oldSoalId);
        if (oldSoal && typeof props.selectAnswer === "function") {
          await props.selectAnswer(oldSoal, null);
        }
      }

      if (typeof props.selectAnswer === "function") {
        await props.selectAnswer(soal, item);
      }

      item.selectedSoal = soal.idsoal;
      draggingItem.value = null;
    };

    const onDropToOptions = async () => {
      const item = draggingItem.value;
      if (!item) return;

      const oldSoalId = item.selectedSoal;
      if (oldSoalId) {
        const oldSoal = props.list.find((s) => s.idsoal === oldSoalId);
        if (oldSoal && typeof props.selectAnswer === "function") {
          await props.selectAnswer(oldSoal, null);
        }
      }

      item.selectedSoal = null;
      draggingItem.value = null;
    };

    const clickToPlace = async (item) => {
      const emptySlot = props.list.find(
        (soal) => getSelectedForSoal(soal).length === 0
      );
      if (!emptySlot) return;

      if (typeof props.selectAnswer === "function") {
        await props.selectAnswer(emptySlot, item);
      }
      item.selectedSoal = emptySlot.idsoal;
    };

    const clickToReturn = async (item) => {
      const oldSoalId = item.selectedSoal;
      if (!oldSoalId) return;

      const oldSoal = props.list.find((s) => s.idsoal === oldSoalId);
      if (oldSoal && typeof props.selectAnswer === "function") {
        await props.selectAnswer(oldSoal, null);
      }
      item.selectedSoal = null;
    };

    return {
      getList,
      getSelectedForSoal,
      onDrop,
      onDropToOptions,
      startDrag,
      clickToPlace,
      clickToReturn,
    };
  },

  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      user_name: localStorage.session_name,
      pathPhoto: localStorage.session_path_photo,
      pathPhotoFull:
        process.env.VUE_APP_BACKEND_URL + localStorage.session_path_photo,
      modalProgress: false,
      link: process.env.VUE_APP_BACKEND_URL,

      totalSoal: Number(this.soalStats.total ?? 0) - Number(this.list.length),
    };
  },
  methods: {
    selesai() {
      Swal.fire({
        icon: "warning",
        title: "Konfirmasi!",
        text: "Apakah Anda Yakin?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            icon: "success",
            title: "Selesai!",
            text: "Jawaban berhasil di simpan",
            timer: 2000,
            timerProgressBar: true,
          });
          this.modalProgress = false;
        } else {
          this.modalProgress = false;
        }
      });
    },
    setHeightDropZoneJawaban() {
      let heightPilihan = $(".pilihan-zone").height();
      $(".jawaban-zone").height(heightPilihan);
    },
    preview(url) {
      this.$emit("showImage", url);
    },
  },
  mounted() {
    // this.setHeightDropZoneJawaban();
    // const self = this;
  },
  updated() {
    // this.setHeightDropZoneJawaban();
    const self = this;
    $(".drag-el > img")
      .addClass("image-soal")
      .wrap("<div class='container-image-soal'></div");
    // $(".image-soal").after(
    //   `<div
    //     class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
    //   >
    //     <button
    //       class="btn btn-success btn-sm preview-btn"
    //     >
    //       <i class="fa fa-search"></i> Preview
    //     </button>
    //   </div>`
    // );

    $(".image-soal").click(function () {
      self.previewImage = true;
      self.urlSrc = $(this).attr("src");
      self.$emit("showImage", $(this).attr("src"));
      // console.log($(this).attr("src"), self);
    });
  },
};
</script>
>

<template>
  <div class="mym-question-body">
    <div class="mym-question-cardbox">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          Soal
          <span class="mym-actived-number">{{ soalStats.total }}</span>
        </div>
      </div>

      <div>
        <table
          class="table align-middle table-striped table-bordered font-size-14 h-100"
        >
          <thead class="table-primary">
            <tr>
              <td width="5%" style="text-align: center">No</td>
              <td width="50%">Soal</td>
              <td width="35%">Jawab</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(soal, index) in list" :key="soal.idsoal">
              <td width="5%" style="text-align: center; vertical-align: top">
                {{ totalSoal + index + 1 }}
              </td>
              <td width="50%" style="vertical-align: top">
                <div class="pertanyaan" v-html="soal.pertanyaan"></div>

                <br />
                <br />
                <div class="w-100 text-center">
                  <div
                    class="container-image-soal"
                    style="margin: auto"
                    v-if="soal.soal_image"
                  >
                    <img
                      v-if="soal.soal_image"
                      :src="link + soal.soal_image"
                      class="image"
                    />
                    <div
                      class="middle d-flex flex-column gap-2 align-items-center justify-content-center"
                    >
                      <button
                        class="btn btn-success btn-sm"
                        @click="preview(link + soal.soal_image)"
                      >
                        <i class="fa fa-search"></i> Preview
                      </button>
                    </div>
                  </div>
                </div>
              </td>
              <td width="35%" style="vertical-align: top">
                <div
                  class="drop-zone jawaban-zone"
                  style="border-radius: 5px; min-height: 50px;"
                  @drop="onDrop($event, soal)"
                  @dragenter.prevent
                  @dragover.prevent
                  @dragleave="onDragLeave"
                >
                  <div
                    v-if="getSelectedForSoal(soal).length === 0"
                    class="placeholder"
                  >
                    <span> Letakkan jawaban Anda di sini </span>
                  </div>
                  <div
                    v-for="item in getSelectedForSoal(soal)"
                    :key="item.idjawaban"
                    style="border-radius: 5px; cursor: pointer;"
                    class="drag-el"
                    draggable="true"
                    @dragstart="startDrag($event, item)"
                    @click="clickToReturn(item)"
                    title="Klik untuk kembalikan ke daftar jawaban"
                    v-html="item.jawaban"
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Footer -->
      <div class="mym-footer justify-content-end">
        <button
          type="button"
          class="mym-btn mym-bg-warning fw-bold"
          @click="$emit('modalProgressFinal')"
          style="width: 200px"
        >
          Selesai
        </button>
      </div>
    </div>
  </div>

  <!-- ================= OPTIONS SECTION ================= -->
  <div
    class="mym-question-body answerlist-box"
    style="max-width: 30%"
    :style="{ top: height + '%', height: `calc(100vh - ${height}vh)`}"
  >
    <div class="mym-question-cardbox d-flex flex-column" style="height: 100%;">
      <h4 class="mym-title-header">Pilihan Jawaban</h4>
      <div
        class="drop-zone pilihan-zone flex-grow-1"
        style="border-radius: 5px; overflow: auto;"
        @drop="onDropToOptions($event)"
        @dragenter.prevent
        @dragover.prevent
      >
        <div
          v-for="item in getList()"
          :key="item.idjawaban"
          style="border-radius: 5px"
          class="m-2"
          draggable="true"
          @dragstart="startDrag($event, item)"
          @click="clickToPlace(item)"
          :title="list.some(s => getSelectedForSoal(s).length === 0) ? 'Klik untuk menempatkan jawaban' : 'Semua kolom sudah terisi'"
          :style="{ cursor: list.some(s => getSelectedForSoal(s).length === 0) ? 'pointer' : 'not-allowed' }"
        >
          <div class="drag-el" v-html="item.jawaban"></div>
          <!-- {{ item.jawaban }} -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.drop-zone {
  background-color: #ccc;
  padding: 5px;
  /* height:50px; */
  min-height: 50px;
  text-align: center;
}

.drag-el {
  background-color: #556ee6;
  color: white;
  padding: 5px;
}

.placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ccc;
  font-style: italic;
  padding: 5px;
  box-sizing: border-box;
}
.placeholder span {
  font-size: 1.1rem;
  color: #000000;
  user-select: none; /* Tambahkan ini */
  pointer-events: none; /* Opsional: agar tidak bisa diklik juga */
}

.drag-el img {
  text-align: center;
  width: 80% !important;
  max-width: 500px;
}
</style>